import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../../lib/brand";

/**
 * Marketing brand mark — uses the user-uploaded ecomcatalog.ai logo image.
 * Image has a white square canvas, so we render it inside a rounded white "app-icon"
 * tile to make it look intentional on the dark obsidian theme.
 */
export default function BrandMark({ size = "md", to = "/" }) {
  const sz = size === "sm" ? 28 : size === "lg" ? 48 : 36;
  const textSize = size === "sm" ? "text-base" : size === "lg" ? "text-2xl" : "text-xl";

  return (
    <Link
      to={to}
      className="inline-flex items-center gap-2.5 group"
      data-testid="mkt-brand-mark"
    >
      <span
        className="shrink-0 grid place-items-center rounded-xl bg-white shadow-[0_4px_18px_-4px_rgba(79,70,229,0.55),inset_0_0_0_1px_rgba(255,255,255,0.4)]"
        style={{ width: sz, height: sz }}
      >
        <img
          src={LOGO_URL}
          alt="EcomCatalog AI"
          className="object-contain select-none"
          style={{ width: sz * 0.86, height: sz * 0.86 }}
          draggable={false}
        />
      </span>
      <span className={`font-mkt-display font-semibold tracking-tight ${textSize}`}>
        <span
          style={{
            background: "linear-gradient(135deg, #818CF8 0%, #A78BFA 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          ecom
        </span>
        <span className="mkt-gradient-text-vivid">catalog</span>
        <span
          className="text-[0.55em] font-bold tracking-[0.18em] uppercase ml-1.5 px-1.5 py-0.5 rounded align-middle"
          style={{
            background: "linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)",
            color: "#FFFFFF",
            boxShadow: "0 4px 14px -4px rgba(124,58,237,0.55)",
          }}
        >
          .AI
        </span>
      </span>
    </Link>
  );
}
